export default function Breadcrumb({ items }) {
    return (
        <div id="path">
            <ul className="flex flex-wrap ml-4 justify-center text-gray-400 mt-2">
                {items.map((item, index) => (
                    <li
                        key={index}
                        className={index === items.length - 1 ? "active" : ""}
                    >
                        <a href={item.href} target="_self">
                            {item.label}
                        </a>
                        {index !== items.length - 1 && <span> &nbsp;-&nbsp; </span>}
                    </li>
                ))}
            </ul>
        </div>
    );
}